import { TranslationObject } from '../../i18n/translation';

const namespace = 'practicetypes';
const translations: TranslationObject = {
  modalTitle: {
    id: `${namespace}.modalTitle`,
    nb: 'Legg til en praksistype for avtalen',
    en: 'Add a practice type to the agreement',
  },
  modalSubtitle: {
    id: `${namespace}.modalSubtitle`,
    nb: 'Søk etter praksistypekode eller praksistypenavn i feltet under. Informasjon om hvilke emner som er tilknyttet valgt praksistype vil deretter vises.',
    en: 'Search for practice type code or practice type name in the field below. Information regarding which topics are affiliated with the selected practice type will then appear.',
  },
  addPracticeType: {
    id: `${namespace}.addPracticeType`,
    nb: 'Legg til praksistype',
    en: 'Add practice type',
  },
  removePracticeTypes: {
    id: `${namespace}.removePracticeTypes`,
    nb: 'Fjern alle praksistyper',
    en: 'Remove all practice types',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  practiceTypesLabel: {
    id: `${namespace}.practiceTypesLabel`,
    nb: 'Søk etter praksistypekode eller praksistypenavn',
    en: 'Search for practice type code or practice type name',
  },
  practiceTypeCode: {
    id: `${namespace}.practiceTypeCode`,
    nb: 'Praksistypekode',
    en: 'Practice type code',
  },
  practiceTypeName: {
    id: `${namespace}.practiceTypeName`,
    nb: 'Praksistypenavn',
    en: 'Practice type name',
  },
  action: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },
  delete: {
    id: `${namespace}.delete`,
    nb: 'Slett',
    en: 'Delete',
  },
  emneCode: {
    id: `${namespace}.emneCode`,
    nb: 'Emnekode',
    en: 'Subject code', // TODO Is this correct?
  },
  emneName: {
    id: `${namespace}.emneName`,
    nb: 'Emnenavn',
    en: 'Subject name', // TODO Is this correct?
  },
};

export default translations;
